import OwnerSubHeader from "@/components/OwnerSubHeader";
import SecurityPolicyCard from "@/components/SecurityPolicyCard";
import AdminUsers from "@/pages/AdminUsers";

export default function PeoplePage() {
  return (
    <div className="space-y-5" data-testid="owner-people-page">
      <OwnerSubHeader title="Manage People" subtitle="Roles · Pending · PIN reset · Security" />
      <SecurityPolicyCard />
      <AdminUsers />
    </div>
  );
}
